"use client";

import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

type PricingReturnToOptionsButtonProps = Readonly<{
  label: string;
  targetId?: string;
}>;

export default function PricingReturnToOptionsButton({
  label,
  targetId = "plans",
}: PricingReturnToOptionsButtonProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => {
      const target = document.getElementById(targetId);
      if (!target) {
        setIsVisible(false);
        return;
      }

      const rect = target.getBoundingClientRect();
      setIsVisible(rect.bottom < 96);
    };

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);
    return () => {
      window.removeEventListener("scroll", updateVisibility);
      window.removeEventListener("resize", updateVisibility);
    };
  }, [targetId]);

  if (!isVisible) return null;

  return (
    <a
      className="fixed left-1/2 top-20 z-[70] inline-flex -translate-x-1/2 items-center gap-2 rounded-full border border-primary/20 bg-white/95 px-4 py-2 text-sm font-bold text-primary shadow-lg shadow-slate-900/10 ring-1 ring-slate-200 backdrop-blur transition hover:bg-primary hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35 sm:px-5"
      href={`#${targetId}`}
    >
      <ArrowUp aria-hidden="true" className="h-4 w-4 shrink-0" />
      <span>{label}</span>
    </a>
  );
}
